import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationCancel, Router } from '@angular/router';
import { first } from 'rxjs/operators';

import { AuthenticationService } from '@app/shared/services/authentication.service';
import { validateUsername } from '@app/shared/validators/username.validator';
import { FormControlUtils } from '@app/util/form-group-utils';

@Component({
  templateUrl: './admin-login-form.component.html',
  styleUrls: ['./admin-login-form.component.scss']
})
export class AdminLoginFormComponent implements OnInit {

  loginForm: FormGroup;

  message: string;

  private returnUrl: string;

  constructor(private readonly formBuilder: FormBuilder,
              private readonly router: Router,
              private readonly activatedRoute: ActivatedRoute,
              private readonly authenticator: AuthenticationService) {
  }

  ngOnInit() {

    this.determineReturnURL();
    this.checkIfUserIsLoggedIn();
    this.initForm();

    // Handle the situation, when the logged user has no authorities to use the system.
    const that = this;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationCancel) {
        if ((event.url !== '/admin-login') && event.url.startsWith('/admin') && that.authenticator.isLoggedIn()) {
          that.message = 'Your access is not granted. Please contact DAR directly for further instruction.';
          that.router.navigate(['/admin-login']);
        }
      }
    });
  }

  hasError(controlName: string, validation?: string) {
    const control = this.loginForm.controls[controlName];
    if (validation) {
      return control.errors[validation];
    } else {
      return control.errors && control.touched;
    }
  }

  onSubmit() {
    FormControlUtils.markAllTouched(this.loginForm);

    if (this.loginForm.invalid) {
      return;
    }

    this.message = null;

    this.authenticator.login(this.loginForm.value)
      .pipe(first())
      .subscribe(
        data => {
          if (data) {
            this.router.navigate([this.returnUrl]);
          } else {
            this.message = 'Invalid username and/or password. Please try again.';
          }
        },
        error => {
          this.message = 'Unable to perform the authentication. Please, contact customer support.';
        });
  }

  private determineReturnURL() {
    const returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'];
    if (returnUrl && returnUrl !== '/admin-login') {
      this.returnUrl = returnUrl;

      return;
    }

    this.returnUrl = '/admin';
  }

  private checkIfUserIsLoggedIn() {
    if (!this.authenticator.isLoggedIn()) {
      return;
    }
    this.router.navigate([this.returnUrl]);
  }

  private initForm() {
    const user = this.authenticator.getCurrentUser();
    this.loginForm = this.formBuilder.group({
      username: [user ? user.username : '', [Validators.required, validateUsername]],
      password: ['', Validators.required]
    });
  }

}
